import { render, staticRenderFns } from "./Writing2.vue?vue&type=template&id=13ba1784&scoped=true"
import script from "./Writing2.vue?vue&type=script&lang=js"
export * from "./Writing2.vue?vue&type=script&lang=js"
import style0 from "./Writing2.vue?vue&type=style&index=0&id=13ba1784&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ba1784",
  null
  
)

export default component.exports